// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__O31Ou","content":"styles_content__3vXYd","flexButton":"styles_flexButton__1svsi","formikErrors":"styles_formikErrors__13Mm0"};